import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFirestore } from "angularfire2/firestore";
import { of } from 'rxjs';
import { leftJoin } from '../../providers/database/leftjoin';

@Injectable()
export class DoctorProvider {

  constructor(
    private afs: AngularFirestore
  ) {}

  listDoctors(program_id)  {
    return this.afs.collection<any>(`program/${program_id}/doctors`, ref =>
      ref.orderBy("last_name", "asc")
    );
  }

  getDoctor(program_id: string, doctor_id: string) {
    return this.afs.collection<any>(`program/${program_id}/doctors`).doc(doctor_id);
  }

  searchDoctors(program_id: string, startsWith = '') {
      const end = startsWith.replace(/.$/, c => String.fromCharCode(c.charCodeAt(0) + 1),);
      console.log('Search: ', startsWith, end);
      return this.afs.collection<any>(`program/${program_id}/doctors`, ref =>
        ref
        .where('last_name', '>=', startsWith)
        .where('last_name', '<', end)
        .orderBy('last_name')
      )
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .pipe( 
        leftJoin(this.afs, 'program_institution_id', `program/${program_id}/clinics`, 1)
      )
  }

  addDoctor(program_id: string, doctor: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    doctor = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...doctor };
    return this.afs.collection<any>(`program/${program_id}/doctors`).doc(doc_id).set(doctor);
  }

  updateDoctor(program_id: string, doctor_id, doctor: any, user: any)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    doctor = { updatedAt, updatedBy, ...doctor };
    return this.afs.collection<any>(`program/${program_id}/doctors`).doc(doctor_id).update(doctor);
  }

  deleteDoctor(program_id: string, doctor_id: string)  {
    var batch = this.afs.firestore.batch();
    const docRef = this.afs.doc(`program/${program_id}/doctors/${doctor_id}`).ref;
    batch.delete(docRef);
    return batch.commit();
  }
}



// WEBPACK FOOTER //
// ./src/providers/doctor/doctor.ts